import { browser } from '$app/environment';
import { Page } from '$lib/utils/page';
import { pageConditions } from './__config/conditions';
import { policy, policyExceptionHandler } from './-policy';

export const prerender = true;

/**
 * Loads the page data
 * @returns {Promise<{page: Page} | undefined>} - The page data
 */
export async function load() {
	// TODO this was all autogenerated by Cursor, there are not real values
	const metadata = {
		metaTag: [
			{
				content:
					'Forgot your ABCmouse password? Reset it here to get back to learning with your child.',
				name: 'description'
			},
			{
				content:
					'Forgot your ABCmouse password? Reset it here to get back to learning with your child.',
				property: 'og:description'
			},
			{
				content: 'ABCmouse Forgot Password | Reset Your Password',
				property: 'og:title'
			},
			{
				content: 'https://www.abcmouse.com/abc/forgot-password/',
				property: 'og:url'
			}
		],
		schemaOrg: {
			graph: {
				webPage: {
					description:
						'Forgot your ABCmouse password? Reset it here to get back to learning with your child.',
					id: 'https://www.abcmouse.com/abc/forgot-password/#webpage',
					name: 'ABCmouse Forgot Password | Reset Your Password',
					url: 'https://www.abcmouse.com/abc/forgot-password/'
				}
			}
		},
		title: 'ABCmouse Forgot Password | Reset Your Password'
	};
	if (browser) {
		const page = new Page({
			conditions: pageConditions,
			metadata,
			policies: { policy, policyExceptionHandler },
			routePath: '/forgot-password'
		});

		return {
			page
		};
	}
}
